import React, { useEffect, useRef, useState } from "react";
import LeafletMap from "../LeafletMap";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function DashboardPage({ t, onBack }) {
  const [dashboard, setDashboard] = useState(null);
  const [mapData, setMapData] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/dashboard"),
      api.get("/dashboard/complaints-map"),
    ])
      .then(([d, m]) => {
        setDashboard(d.data);
        setMapData(m.data.complaints || []);
      })
      .catch(() => {});
  }, []);

  return (
    <SimplePage title="Public Civic Dashboard" onBack={onBack}>
      <div className="stats-grid">
        <CivicStat icon={<FileText />} value={dashboard?.stats?.reported ?? 0} label={t.reported} />
        <CivicStat icon={<Clock3 />} value={dashboard?.stats?.in_progress ?? 0} label={t.progress} />
        <CivicStat icon={<CheckCircle2 />} value={dashboard?.stats?.resolved ?? 0} label={t.resolved} />
        <CivicStat icon={<Building2 />} value={dashboard?.stats?.services ?? 0} label={t.servicesCount} />
      </div>

      <div className="civic-data-panel">
        <h2>Issue Map</h2>
        <LeafletMap complaints={mapData} />
      </div>

      <div className="civic-data-panel">
        <h2>Recent Public Issues</h2>
        {(dashboard?.complaints || []).slice(0, 30).map((item) => (
          <div className="data-row" key={item.tracking_id}>
            <span>
              <strong>{item.tracking_id}</strong> · {item.title}
            </span>
            <b>{item.status}</b>
          </div>
        ))}
      </div>
    </SimplePage>
  );
}



export default DashboardPage;
